import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  getFailedAllowance,
  normalizeAllowance,
} from "../../../utils/redemptionAllowance";

const initialState = {
  loading: false,
  month: "",
  timezone: "",
  resetsOn: "",
  generatedAt: "",
  groups: [],
  unattributed: null,
  failed: false,
};

const fetchRedemptionAllowance = createAsyncThunk(
  "fetch/redemption-allowance",
  async () => {
    try {
      const result = await axios.get(
        "https://apac.api.capillarytech.com/b2c/x/neo/integration/v1/loyalty/redemption-allowance",
        {
          headers: {
            "x-cap-neo-dag-scope": "org",
          },
        },
      );
      return normalizeAllowance(result?.data);
    } catch (err) {
      console.log(err);
      return getFailedAllowance();
    }
  },
);

const redemptionAllowanceSlice = createSlice({
  name: "redemption-allowance",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRedemptionAllowance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRedemptionAllowance.fulfilled, (state, action) => {
      state.loading = false;
      state.month = action.payload?.month || "";
      state.timezone = action.payload?.timezone || "";
      state.resetsOn = action.payload?.resetsOn || "";
      state.generatedAt = action.payload?.generatedAt || "";
      state.groups = action.payload?.groups || [];
      state.unattributed = action.payload?.unattributed || null;
      state.failed = Boolean(action.payload?.failed);
    });
    builder.addCase(fetchRedemptionAllowance.rejected, (state) => {
      state.loading = false;
      state.groups = [];
      state.failed = true;
    });
  },
});

export default redemptionAllowanceSlice.reducer;
export { fetchRedemptionAllowance };
